const realpressSetupPages = () => {
    const pageSettingNode = document.querySelector('.realpress-page-setting');
    if (!pageSettingNode) {
        return;
    }

    const createPagesButtonNode = pageSettingNode.querySelector('button#realpress-create-all-pages');
    if (!createPagesButtonNode) {
        return;
    }

    const {__} = wp.i18n;

    const agentListPageId = REALPRESS_GLOBAL_OBJECT.agent_list_page_id || '';
    const termsAndConditionsPageId = REALPRESS_GLOBAL_OBJECT.terms_and_conditions_page_id || '';
    const becomeAnAgentPageId = REALPRESS_GLOBAL_OBJECT.become_an_agent_page_id || '';
    const wishlistPageId = REALPRESS_GLOBAL_OBJECT.wishlist_page_id || '';

    const agentListPageNode = pageSettingNode.querySelector('#realpress_agent_list_page');
    const termsAndConditionsPageNode = pageSettingNode.querySelector('#realpress_terms_and_conditions_page');
    const becomeAnAgentPageNode = pageSettingNode.querySelector('#realpress_become_an_agent_page');
    const wishlistPageNode = pageSettingNode.querySelector('#realpress_wishlist_page');

    createPagesButtonNode.addEventListener('click', async function (event) {
        event.preventDefault();
        createPagesButtonNode.disabled = true;
        createPagesButtonNode.insertAdjacentHTML('afterbegin', ' <i class="fa fa-spinner fa-spin"></i>' + ' ');
        if (agentListPageNode) {
            let agentListResult = await create_page(agentListPageId, agentListPageNode.tomselect, __('Agent List', 'realpress'));
            addValueToSelect(agentListResult, agentListPageNode);
        }

        if (termsAndConditionsPageNode) {
            let termsAndConditionsResult = await create_page(termsAndConditionsPageId, termsAndConditionsPageNode.tomselect, __('Terms and Conditions', 'realpress'));
            addValueToSelect(termsAndConditionsResult, termsAndConditionsPageNode);
        }

        if (becomeAnAgentPageNode) {
            let becomeAnAgentResult = await create_page(becomeAnAgentPageId, becomeAnAgentPageNode.tomselect, __('Become an Agent', 'realpress'));
            addValueToSelect(becomeAnAgentResult, becomeAnAgentPageNode);
        }

        if (wishlistPageNode) {
            let wishlisttResult = await create_page(wishlistPageId, wishlistPageNode.tomselect, __('WishList', 'realpress'));
            addValueToSelect(wishlisttResult, wishlistPageNode);
        }
        createPagesButtonNode.querySelector('i.fa-spinner').remove();
        createPagesButtonNode.disabled = false;
    });
};


const create_page = (pageId, node, title) => {
    const restNamespace = REALPRESS_GLOBAL_OBJECT.rest_namespace || '';
    if (pageId) {
        node.setValue([pageId]);

        return new Promise(resolve => resolve('success'));
    } else {
        let data = {title, post_type: 'page', post_status: 'publish'}
        return wp.apiFetch({
            path: '/' + restNamespace + '/page',
            method: 'POST',
            data,
        })
    }
}

const addValueToSelect = (result, selectNode) => {
    if (result.status && result.status === 'success' && result.data) {
        selectNode.tomselect.addOption({value: result.data.id, text: result.data.title});
        selectNode.tomselect.setValue([result.data.id]);
    }
}

export default realpressSetupPages;